import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;

}


export const SettingsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getAge}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getSettingsById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getAgeById}${id}/`,
        method: "GET",
      }),
    }),
    addSettings: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addAge,
        method: "POST",
        body,
      }),
    }),
    updateSettings: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateAge}?id=${id}`,
        method: "POST",
        body,
      }),
    }),

    deleteSettings: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteAge}${id}/`,
        method: "DELETE",
      }),
    }),
      getTemplate: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getTemplate}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getTemplateById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getTemplateById}${id}/`,
        method: "GET",
      }),
    }),
    addTemplate: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addTemplate,
        method: "POST",
        body,
      }),
    }),
    updateTemplate: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateTemplate}?id=${id}`,
        method: "POST",
        body,
      }),
    }),

    deleteTemplate: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteTemplate}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
useLazyGetSettingsQuery,
useLazyGetSettingsByIdQuery,
useAddSettingsMutation,
useUpdateSettingsMutation,
useDeleteSettingsMutation,

//Template
useAddTemplateMutation,
useDeleteTemplateMutation,
useLazyGetTemplateByIdQuery,
useLazyGetTemplateQuery,
useGetTemplateQuery,
useUpdateTemplateMutation
} = SettingsApi;
